'use strict';

var _ = require('lodash');
var PricingAnalysisDepartureDatesTransformerFactory = function PricingAnalysisDepartureDatesTransformerFactory(DataTransformer, momentService) {
  function PricingAnalysisDepartureDatesTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'pricing-analysis-departure-dates';
    this.targetType = 'pricing-analysis-departure-dates';
  }
  PricingAnalysisDepartureDatesTransformer.prototype = Object.create(DataTransformer.prototype);
  PricingAnalysisDepartureDatesTransformer.constructor = PricingAnalysisDepartureDatesTransformer;
  PricingAnalysisDepartureDatesTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  PricingAnalysisDepartureDatesTransformer.prototype.isCacheable = function () {
    return false;
  };
  PricingAnalysisDepartureDatesTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  PricingAnalysisDepartureDatesTransformer.prototype.transform = function (data) {
    var domainData = _.get(data, 'domain.flattenedPriceRecommendationDepartureDate', []);
    return _.map(domainData, function (data) {
      data.averageFareChange = data.averageFareChange || 0;
      data.departureDate = momentService.of(data.departureDate, momentService.FIELD.PRICING_DEPARTURE_DATE);
      data.eventTimeStamp = momentService.of(data.eventTimeStamp, momentService.FIELD.PRICING_EVENT_TIME_STAMP);
      data.numberOfEffectedServicesNew = data.numberOfEffectedServices - data.numberOfEffectedServicesExtensions;
      return data;
    });
  };
  return PricingAnalysisDepartureDatesTransformer;
};
PricingAnalysisDepartureDatesTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = PricingAnalysisDepartureDatesTransformerFactory;